import * as React from "react"
import * as _ from "lodash"
import { IPatientConcern } from "@curefit/ehr-common";
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import {LOADING_STATE} from "../../utils/AppUtils"
import {ITypeFormQuestionnaire} from "../../models/ITypeFormQuestionnaire";
import {PatientDietRecallEditorProps} from "../../components/patient/edit/PatientDietRecallEditor";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import IDietRecall from "../../models/IDietRecall";
import IDishCatalogueResponse from "../../models/maverick/IDishCatalogueResponse";

/*
 * Created by aditya on 12/07/18
 */

export interface DietRecallEditViewContProps {
    patientId: number,
    dietInfo: IDietRecall,
    displayMode?: EditViewDisplayMode,
    staticFoodTypes: IStaticDataValue[],
    staticCuisines: IStaticDataValue[],
    fetchPatientDietInfo?: (patientId: number) => any,
    fetchStaticSymptomData?: (input: string) => Promise<any>,
    savePatientDietInfo?: (patientId: number, patientConcern: IPatientConcern[]) => any,
    fetchDishByDishName: (input: string) => Promise<IDishCatalogueResponse | IDishCatalogueResponse[]>,
    questionnaire?: ITypeFormQuestionnaire[];
    typeFormMapping?: any;
}

export interface DietRecallEditViewContState {
    updatedDietInfo: {item: IDietRecall},
    isPatientDietInfoLoaded: LOADING_STATE,
    error: string,
    errorDetails: string
}

class DietRecallEditViewCont extends React.Component<DietRecallEditViewContProps, DietRecallEditViewContState> {
    constructor(props: DietRecallEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    getStateFromProps = (props: DietRecallEditViewContProps) => {
        let currState: DietRecallEditViewContState = {
            updatedDietInfo: {},
            isPatientDietInfoLoaded: LOADING_STATE.NOT_INITIALIZED,
            error: this.state ? this.state.error : "",
            errorDetails: this.state ? this.state.errorDetails : ""
        }
        if ( _.isNull(props.dietInfo) ) {
            props.fetchPatientDietInfo(this.props.patientId);
            currState.isPatientDietInfoLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedDietInfo = {};
            if (!_.isEmpty(props.dietInfo)) {
                let clonePatientDiet = Object.assign({}, props.dietInfo);
                currState.updatedDietInfo = {item: clonePatientDiet};
            }
            currState.isPatientDietInfoLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getUpdatedDietFromProps = (props: DietRecallEditViewContProps): {item: IDietRecall} => {
        let currUpdatedDiet: {item: IDietRecall};
        let clonePatientDiet = Object.assign({}, props.dietInfo);
        currUpdatedDiet = {item: clonePatientDiet};
        return currUpdatedDiet;
    }

    getDietRecallEditViewProps() {
        let patientConcernViewProps = {
            dietInfo: this.props.dietInfo,
            questionnaire: this.props.questionnaire,
            questionIdList: this.typeFormQuestionIdList()
        }
        let patientConcernEditorProps: PatientDietRecallEditorProps = {
            staticFoodTypes: this.props.staticFoodTypes,
            staticCuisines: this.props.staticCuisines,
            updatedDietInfo: this.state.updatedDietInfo,
            updateDietInfo: this.updatePatientDietInfo,
            fetchStaticSymptomData: this.props.fetchStaticSymptomData,
            fetchDishByDishName: this.props.fetchDishByDishName,
            questionnaire: this.props.questionnaire,
            questionIdList: this.typeFormQuestionIdList()
        }
        return {"view": patientConcernViewProps, "edit": patientConcernEditorProps};
    }

    typeFormQuestionIdList = (): string[] => {
        let questionList = [];
        questionList = this.props.typeFormMapping.filter((item: any) => item.group === "DIET");
        if (!_.isEmpty(questionList)) {
            questionList = questionList.map((item: any) => item.code);
        }
        return questionList;
    }

    updatePatientDietInfo = (updatedDietInfo: {item: IDietRecall}) => {
        this.setState({updatedDietInfo});
    }

    saveDietInfo() {

    }

    getSaveObject = (): IDietRecall => {
        let dietRecall = { ...this.state.updatedDietInfo.item };
        return dietRecall;
    }

    cancelActionHandler() {
        this.setState({ updatedDietInfo: this.getUpdatedDietFromProps(this.props) });
    }

    render() {
        return (
            <div>
                <EditViewCard cardTitleDisplay={"Diet Recall"} templateName={"dietRecall"}
                              templateProps={this.getDietRecallEditViewProps()}
                              lastEditedEpoch={new Date().getTime()} saveActionHandler={this.saveDietInfo}
                              cancelActionHandler={this.cancelActionHandler}
                              displayMode={this.props.displayMode}
                />
            </div>
        )
    }
}

export default DietRecallEditViewCont;